import FormElementMixin from '../mixins/FormElementMixin.js';

Vue.asyncComponent('ak-date-picker', {
    mixins: [FormElementMixin],
    data() {
        return {
            selectedDatepickerDate: null,
            selectedDate: null,
            datepicker: false,
        }
    },
    watch: {
        selectedDatepickerDate() {
            this.datepicker = false;
            this.selectedDate = this.$moment(this.selectedDatepickerDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
            this.$emit('input', this.$moment(this.selectedDate, 'DD/MM/YYYY').toISOString(true));
        }
    },
    methods: {
        changeSelectedDate() {
            if(this.selectedDate) {
                this.selectedDatepickerDate = this.$moment(this.selectedDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
                this.$emit('input', this.$moment(this.selectedDate, 'DD/MM/YYYY').toISOString(true));
                this.$emit('blur');
            }
        }
    },
    created() {
		if (this.value) {
            this.selectedDate = this.$moment(this.value).format('DD/MM/YYYY');
            this.selectedDatepickerDate = this.$moment(this.value).format('YYYY-MM-DD');
        } else {
            this.selectedDate = this.$moment().format('DD/MM/YYYY');
            this.selectedDatepickerDate = this.$moment().format('YYYY-MM-DD');
        }

        
		this.$emit('input', this.$moment(this.selectedDate).toISOString(true));
    }
}, 'form/controls/ak-date-picker.html');